var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgFacebook = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 16.7656C32 7.92906 24.8366 0.765625 16 0.765625C7.16344 0.765625 0 7.92906 0 16.7656C0 24.7516 5.85094 31.3709 13.5 32.5713V21.3906H9.4375V16.7656H13.5V13.2406C13.5 9.23063 15.8888 7.01563 19.5434 7.01563C21.2934 7.01563 23.125 7.32813 23.125 7.32813V11.2656H21.1075C19.12 11.2656 18.5 12.4991 18.5 13.7656V16.7656H22.9375L22.2281 21.3906H18.5V32.5713C26.1491 31.3709 32 24.7516 32 16.7656Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFacebook, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/facebook.462e4d74.svg";
export { ForwardRef as ReactComponent };